import { render } from "./inquiry_charts.vue?vue&type=template&id=59c036a0&scoped=true"
import script from "./inquiry_charts.vue?vue&type=script&lang=js"
export * from "./inquiry_charts.vue?vue&type=script&lang=js"

import "./inquiry_charts.vue?vue&type=style&index=0&id=59c036a0&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境/M平台/前端/servicepartner.matchupexpo.com - 外呼合作方端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c036a0"]])

export default __exports__